<template>
  <div>
    <el-form :inline="true" class="demo-form-inline" v-if="!isCoaType">
      
      <div v-for="(item, index) in zdFormattedValue" :key="index">

        <el-form-item :label="labelText('Rev')">
          {{ index + 1 }}
        </el-form-item>
        <el-form-item :label="labelText('Revision Date')">
          <el-date-picker
            v-model="item.revisionDate"
            :placeholder="labelText('Revision Date')"
            :disabled="setDisable(item)"
            format="MM/dd/yyyy"
            value-format="MM/dd/yyyy"
            type="date"
            style="width: 140px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="labelText('Requested By')">
          <el-input
            v-model="item.requestedBy"
            :disabled="setDisable(item)"
            :placeholder="labelText('Requested By')"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="labelText('Revised Notes')">
          <el-input
            v-model="item.itemsRevised"
            :disabled="setDisable(item)"
            :placeholder="labelText('Revised Notes')"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="labelText('Edited By')">
          <el-input
            v-model="item.editedBy"
            :disabled="setDisable(item)"
            :placeholder="labelText('Edited By')"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="labelText('Reason')">
          <el-input
            v-model="item.reason"
            :disabled="setDisable(item) || getAuthShow()"
            :placeholder="labelText('Reason')"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="labelText('Approved By')">
          <el-input
            v-model="item.approvedBy"
            :placeholder="labelText('Approved By')"
            :disabled="setDisable(item) || getAuthShow()"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 120px">
          <el-button
            type="text"
            :disabled="setAddRowDisable(item,index) || getAuthShow()"
            v-if="showAddRecords(item,index)"
            @click="completeHandle(item)"
            >{{ $t("action.add") }}</el-button
          >
          <el-button
            type="text"
            :disabled="setAddRowDisable(index) || getAuthShow()"
            v-if="showDeleteRecords(item)"
            @click="deleteHandle(index)"
            >{{ $t("action.delete") }}</el-button
          >
        </el-form-item>
      </div>
    </el-form>

    <!-- coa 类型显示 -->
    <el-form v-else :inline="true">
      <el-form-item :label="labelText('Coa Rev Update Date')"> 
        <el-input
            v-model="coaRevData.revisionDate"
            :placeholder="labelText('Coa Rev Update Date')"
            :disabled=true
            style="width: 140px"
          ></el-input>
      </el-form-item>
      <el-form-item :label="labelText('Coa Rev Update Version')">
        <el-input
            v-model="coaRevData.revisionVersion"
            :placeholder="labelText('Coa Rev Update Version')"
            :disabled=true
            style="width: 140px"
          ></el-input>
      </el-form-item>
      <el-form-item :label="labelText('Coa Rev Verify Name')">
        <el-input
            v-model="coaRevData.verifyName"
            :disabled=true
            :placeholder="labelText('Coa Rev Verify Name')"
            style="width: 140px"
          ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";
export default {
  name: "ZDRevisionComponents",
  props: {
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  computed: {
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    zdItem() {
      return this.zdComponentState;
    },
    isCoaType() {
      let type = this.$route.query.type;
      return type === "coa";
    },
    labelText() {
      return (label) => {
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    zdFormattedValue: {
      get() {
        //console.info("zdFormattedValue=this.zdItem<><><>:", this.zdItem.value);
        return this.zdItem.value || []; // 确保返回一个数组
      },
      set(value) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        });
      },
    },
  },
  data() {
    return {
      coaRevData:{
        revisionDate:"",
        revisionVersion:"",
        verifyName:""
      }
    };
  },
  created() {
    // console.info('zdFormattedValue:', this.zdFormattedValue);
    
    // 添加完整的空值检查和类型安全
    if (this.zdItem && 
        this.zdItem.value && 
        Array.isArray(this.zdItem.value) && 
        this.zdItem.value.length >= 1 && 
        this.zdItem.value[0]) {
      
      const firstItem = this.zdItem.value[0];
      
      // 安全地处理 revisionDate，确保它是字符串且有效
      if (firstItem.revisionDate && typeof firstItem.revisionDate === 'string' && firstItem.revisionDate.length >= 10) {
        this.coaRevData.revisionDate = firstItem.revisionDate.substring(0, 10);
      } else {
        this.coaRevData.revisionDate = '';
      }
      
      // 安全地处理 reason
      this.coaRevData.revisionVersion = firstItem.reason || '';
      
      // 安全地处理 verifyName
      this.coaRevData.verifyName = firstItem.verifyName || '';
    } else {
      // 如果没有有效数据，设置默认值
      this.coaRevData.revisionDate = '';
      this.coaRevData.revisionVersion = '';
      this.coaRevData.verifyName = '';
    }
    // console.info("coaRevData:",this.coaRevData);
    
    this.$nextTick(() => {
      this.initRevision();
    });
  },
  methods: {
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload);
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    setAddRowDisable() {
      // let pageStatus = localStorage.getItem("pageStatus");
      // return pageStatus === "Detail";
      return false;
    },
    setDisable(item) {
      let pageStatus = this.pageStatus;
      if (pageStatus === "Detail") {
        return true;
      }
      // console.info("item.isComplete111:", item.isComplete);
      return item.isComplete;
    },
    completeHandle() {
      let revision = {
        approvedBy: "",
        editedBy: "",
        isComplete: false,
        reason: "",
        requestedBy: "",
        revisedNotes: "",
        revisionDate: "",
      };
      // 使用 Vuex 更新状态
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: [...this.zdFormattedValue, revision],
      });
    },
    initRevision() {
      if (!this.zdItem.value || this.zdItem.value.length === 0) {
        let revision = {
          approvedBy: "",
          editedBy: "",
          isComplete: false,
          reason: "",
          requestedBy: "",
          revisedNotes: "",
          revisionDate: "",
        };
        // 使用 Vuex 更新状态
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: [revision],
        });
      }
      //console.info("this.zdFormattedValue<><><>:", this.zdFormattedValue);
    },
    optionButtonFlag(item) {
      let pageStatus = this.pageStatus;
      // //console.info("optionButtonFlag pageStatus:", pageStatus);
      // return pageStatus === "Detail" || item.isComplete;
      if (pageStatus === "Detail") {
        return false;
      }
      return item.isComplete;
    },
    showDeleteRecords(item) {
      let pageStatus = this.pageStatus;
      if (pageStatus === "Detail") {
        return false;
      }
      return !item.isComplete;
    },
    showAddRecords(item,index) {
      let pageStatus = this.pageStatus;
      if (pageStatus === "Detail") {
        return false;
      }
      if(this.zdFormattedValue.length==(index+1)){
        return true;
      }
      return !item.isComplete;
    },
    deleteHandle(index) {
      let newValue = [...this.zdFormattedValue];
      newValue.splice(index, 1);
      // 使用 Vuex 更新状态
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: newValue,
      });
    },
  },
};
</script>
